import * as Yup from "yup";

const PrincipleCreationSchema = Yup.object({
  name: Yup.string().required("name is required"),
});
export default PrincipleCreationSchema;
